import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "status", "position"]
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-30",
      dragClass: "shadow-lg",
      onEnd: this.onDragEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async onDragEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const items = this.listTarget.querySelectorAll("[data-track-id]")
    const order = Array.from(items).map(el => parseInt(el.dataset.trackId, 10))

    this.updateStatus("Saving…")

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ order })
      })

      if (response.ok) {
        this.renumber()
        this.updateStatus("Saved")
        setTimeout(() => this.updateStatus(""), 1500)
      } else {
        this.revertOrder(event)
        this.updateStatus("Save failed")
      }
    } catch (error) {
      console.error("Reorder failed:", error)
      this.revertOrder(event)
      this.updateStatus("Save failed")
    }
  }

  renumber() {
    this.positionTargets.forEach((el, i) => { el.textContent = i + 1 })
  }

  revertOrder(event) {
    const { oldIndex, newIndex } = event
    const parent = this.listTarget
    const movedEl = parent.children[newIndex]
    parent.removeChild(movedEl)
    if (oldIndex >= parent.children.length) {
      parent.appendChild(movedEl)
    } else {
      parent.insertBefore(movedEl, parent.children[oldIndex])
    }
  }

  updateStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
